import * as React from "react";

export interface IPartLoadingProps extends React.Props<PartLoading> {
    cssWrapper?: string;
    message?: string | JSX.Element;
    isLoading?: boolean;
}

export interface IPartLoadingState {}

export class PartLoading extends React.Component<IPartLoadingProps, IPartLoadingState> {
    constructor(props: IPartLoadingProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { cssWrapper, message, children } = this.props;
        const { isLoading } = this.props;

        const messageElement = message ? <div className="spinner-message">{message}</div> : null;

        return (
            <div className={isLoading ? "spinner-wrap" : ""}>
                {isLoading &&
                    <div className={"spinner " + cssWrapper}>
                        <div className="spinner-inner" role="status">
                            <span className="sr-only">Loading...</span>
                            <div className="spinner-icon"></div>
                        </div>
                        {messageElement}
                    </div>
                }
                <div className={isLoading ? "part-loading-bg" : ""}>{children}</div>
            </div>
        );
    }
}
